import React, { FC, useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faCheck, faRotate, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { del } from '../../utils/api';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { authUpdateUserCategories } from '../../store/authSlice';

export interface CategoryRemoveProps {
	attendee_id: number,
    category_id: number,
    confirm?: string | null,
    onSuccess: () => void,
};
//
// Удаление категории у пользователя
// Мы передаем сюда attendee_id но это всегда идентификатор пользователя
//
const CategoryRemove:FC<CategoryRemoveProps> = ({ attendee_id, category_id, confirm, onSuccess }) => {
    const user = useAppSelector(store => store.auth.user);
    const dispatch = useAppDispatch();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState(false);
    const [ success, setSuccess ] = useState(false);

	const remove = async (e: React.MouseEvent) => {
        e.stopPropagation();
        if(!window.confirm(confirm ?? undefined)) {
			return;
		}
        setIsLoading(true);
        const result = await del('/catalog', { attendee_id, category_id });
		if(result.error) {
            setError(true);
        } else {
            setSuccess(true);
            // Также необходимо обновить информацию о пользователе в сторе
            if(user) {
                const newCategories = [...user.categories];
                const index = newCategories.indexOf(category_id);
                if(index >= 0) {
                    newCategories.splice(index, 1);
                    dispatch(authUpdateUserCategories(newCategories));
                }
            }
            // Вызываем функцию успеха
            onSuccess();
        }
        setIsLoading(false);
	};

    if(error) return <div className='btn'><span><Icon icon={faCircleExclamation} className='error'/></span></div>;
    if(isLoading) return <div className='btn'><span><Icon icon={faRotate} className='fa-spin accent'/></span></div>;

	return (
        <div className='btn'>
            <span>
                {success ? <Icon icon={faCheck} className='success'/> :
                <Icon icon={faTrashCan} className='accent pointer' onClick={remove}/>}
            </span>
        </div>
    );
};

export default CategoryRemove;
